import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16.37 2a20.16 20.16 0 0 1 0 20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Nfc";
const Nfc = memo(themed(Icon));
export {
  Nfc
};
//# sourceMappingURL=nfc.js.map
